import React, { useState } from "react";
import { useRecoilState } from "recoil";
import { default2FAProps, form2FAProps } from "recoil/atom";
import { ButtonContained, ButtonOutlined } from "components/button/CommonButton";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Stack,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { IntegerInputFormat } from "utils/inputHandler";
import { setRecoilExternalState } from "RecoilExternalState";

export const confirmWith2FA = (onOK, onClose) => {
  setRecoilExternalState(form2FAProps, {
    visible: true,
    onOK,
    onClose,
  });
};

const Form2FaModal = () => {
  const [digitCode, setDigitCode] = useState("");
  const [prop, setProp] = useRecoilState(form2FAProps);

  const { visible, onOK, onCancel } = prop;

  const handleChangeDigitCode = (e) => setDigitCode(IntegerInputFormat(e.target.value, 6));

  const handleCancel = () => {
    if (onCancel) {
      onCancel();
    } else {
      setProp(default2FAProps);
      setDigitCode("");
    }
  };

  const handleConfirmCode = () => {
    if (onOK) {
      onOK({ fa_otp_token: digitCode });
    }
    handleCancel();
  };

  return (
    <Dialog open={visible} onClose={handleCancel} sx={{ "& .MuiPaper-root": { width: 500 } }}>
      <DialogTitle>
        Two Factor Authentication Verify
        <IconButton
          aria-label="close"
          onClick={handleCancel}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Divider sx={{ mb: 3 }} />
        <Stack spacing={3}>
          <TextField
            fullWidth
            label="Enter 6-digit code"
            sx={{ height: 50 }}
            value={digitCode}
            onChange={handleChangeDigitCode}
          />
          <div className="flex gap-2 justify-end">
            <ButtonOutlined sx={{ height: 50 }} onClick={handleCancel}>
              Cancel
            </ButtonOutlined>
            <ButtonContained
              onClick={handleConfirmCode}
              sx={{ height: 50 }}
              disabled={!(digitCode && digitCode.length === 6)}
            >
              Confirm
            </ButtonContained>
          </div>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default Form2FaModal;
